import { useEffect, useContext, useRef } from "react";
import { AuthContext } from "../../context/Authentication";
import { useCartTransfer } from "../../hooks/useCartTransfer";

/**
 * CartTransferManager Component
 * Handles automatic cart transfer when user logs in
 * SIMPLIFIED: Only one trigger condition - user authentication with guest cart items
 */
const CartTransferManager = () => {
  const { state } = useContext(AuthContext);
  const { triggerCartTransfer } = useCartTransfer();
  const processedUserId = useRef(null);

  useEffect(() => {
    // console.log("CartTransferManager useEffect triggered", {
    //   isAuthenticated: state.isAuthenticated,
    //   userId: state.user?.User_Id,
    //   processedUserId: processedUserId.current,
    // });

    // SINGLE CONDITION: User authenticated AND not processed before
    if (
      state.isAuthenticated &&
      state.user?.User_Id &&
      processedUserId.current !== state.user.User_Id
    ) {
      // console.log(
      //   "🔥 CartTransferManager: Triggering transfer for user",
      //   state.user.User_Id
      // );

      // Mark as processed IMMEDIATELY to prevent double execution
      processedUserId.current = state.user.User_Id;

      // Trigger transfer
      triggerCartTransfer();
    }

    // Reset when user logs out
    if (!state.isAuthenticated) {
      processedUserId.current = null;
    }
  }, [state.isAuthenticated, state.user?.User_Id, triggerCartTransfer]);

  return null;
};

export default CartTransferManager;
